// CUSTODY SETUP (UI rebuild batch 4, area `custody-admin`) — where its eight views live, in one place, so the custody
// section's landing (src/screens/v2/custody/, another builder's) can link to them, or mount CustodyAdminRoutes under
// another base by changing BASE alone. The operations screens these views point to (Deposits, Approvals, Balances) are
// that section's; today's paths are used until it names its own.
export const BASE = '/custody-admin';

/** Each view's working screen in the custody section (screens/v2/custody/Custody.tsx; the CC, 3 Nov 2026: links still went to
 *  /custody-admin/*). `addresses` carries a query: add to it with `&`. */
export const CA = {
  addresses: '/custody/deposits?show=addresses',
  issue: '/custody/deposits/new',
  payouts: '/custody/wallets',
  propose: '/custody/wallets/propose',
  keys: '/custody/settings',
  register: '/custody/settings/register',
  settings: '/custody/settings',
  guide: '/custody',
} as const;

/** The custody section's operations views (not this area's). */
export const OPS = {
  deposits: '/custody/deposits',
  approvals: '/custody', // the list is Waiting on you; /custody/approvals only redirects there
  balances: '/custody/balances',
} as const;

/** The Books' wallet register: where the OWNER approves a payout address (Approve payout address, WalletRegister.tsx). */
export const BOOKS_APPROVAL = '/wallets';

/** The doors a landing shows for this area (label ≤ 3 words, sub ≤ 4). */
export const CUSTODY_ADMIN_DOORS: ReadonlyArray<{ to: string; title: string; sub: string }> = [
  { to: CA.addresses, title: 'Deposit addresses', sub: 'Issue and check' },
  { to: CA.payouts, title: 'Payout addresses', sub: 'Approved, tested, whitelisted' },
  { to: CA.keys, title: 'Devices & keys', sub: 'Ledger accounts' },
  { to: CA.settings, title: 'Custody settings', sub: 'Caps, floors, renewals' },
  { to: CA.guide, title: 'Custody flow', sub: 'How funds move' },
];
